import { render } from "./MiniWizardStickyAmount.vue?vue&type=template&id=8ee5eeb4"
import script from "./MiniWizardStickyAmount.vue?vue&type=script&lang=js"
export * from "./MiniWizardStickyAmount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__